import { useBreakpointValue } from '@genial/utils';
import React from 'react';

import { SecondCopyListItemDesktop } from './Desktop';
import { SecondCopyListItemMobile } from './Mobile';
import { SecondCopyListItemTablet } from './Tablet';

export interface SecondCopyListItemProps {
  id: string;
  item: any;
  selected: boolean;
  onCheck: (id: string, selected: boolean) => void;
}

export const SecondCopyListItem: React.FC<SecondCopyListItemProps> = (props) => {
  return useBreakpointValue({
    base: <SecondCopyListItemMobile {...props} />,
    sm: <SecondCopyListItemTablet {...props} />,
    lg: <SecondCopyListItemDesktop {...props} />,
  });
};
